import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-box-id", "id", "data-x", "data-y", "data-width", "data-height"]
const _hoisted_2 = ["x", "y", "rx", "ry", "width", "height", "stroke", "fill"]
const _hoisted_3 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_4 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_5 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_6 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_7 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_8 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_9 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]
const _hoisted_10 = ["x", "y", "width", "height", "fill", "stroke", "stroke-width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomForeignObject = _resolveComponent("CustomForeignObject")!

  return (_ctx.box)
    ? (_openBlock(), _createElementBlock("g", {
        "data-box-id": _ctx.box.id,
        id: _ctx.box.id,
        "data-x": _ctx.box.x,
        "data-y": _ctx.box.y,
        "data-width": _ctx.box.width,
        "data-height": _ctx.box.height,
        key: _ctx.box.id,
        class: _normalizeClass({ 'box-group': _ctx.boxGroupClass, selected: _ctx.selected }),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emitSelectedBox()), ["stop"]))
      }, [
        _createElementVNode("rect", {
          class: _normalizeClass({ box: !_ctx.preview, selected: _ctx.selected }),
          x: _ctx.box.x,
          y: _ctx.box.y,
          rx: _ctx.boxStyle.borderRadius,
          ry: _ctx.boxStyle.borderRadius,
          width: _ctx.box.width,
          height: _ctx.box.height,
          stroke: _ctx.boxStyle.border ? _ctx.boxStyle.stroke : 'none',
          "stroke-width": "0.5",
          fill: _ctx.fill,
          style: _normalizeStyle({ resize: 'both', overflow: _ctx.box.hideOverflowContent ? 'hidden' : 'visible' })
        }, null, 14, _hoisted_2),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, left: !_ctx.preview }),
          x: _ctx.box.absLeftResizePoint.x,
          y: _ctx.box.absLeftResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_3),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, right: !_ctx.preview }),
          x: _ctx.box.absRightResizePoint.x,
          y: _ctx.box.absRightResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_4),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, top: !_ctx.preview }),
          x: _ctx.box.absTopResizePoint.x,
          y: _ctx.box.absTopResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_5),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, bottom: !_ctx.preview }),
          x: _ctx.box.absBottomResizePoint.x,
          y: _ctx.box.absBottomResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_6),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, topLeft: !_ctx.preview }),
          x: _ctx.box.absTopLeftResizePoint.x,
          y: _ctx.box.absTopLeftResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_7),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, topRight: !_ctx.preview }),
          x: _ctx.box.absTopRightResizePoint.x,
          y: _ctx.box.absTopRightResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_8),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, bottomLeft: !_ctx.preview }),
          x: _ctx.box.absBottomLeftResizePoint.x,
          y: _ctx.box.absBottomLeftResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_9),
        _createElementVNode("rect", {
          class: _normalizeClass({ resizePoint: !_ctx.preview, bottomRight: !_ctx.preview }),
          x: _ctx.box.absBottomRightResizePoint.x,
          y: _ctx.box.absBottomRightResizePoint.y,
          width: _ctx.box.resizePointWidth,
          height: _ctx.box.resizePointHeight,
          fill: !_ctx.preview ? '#F9B128' : 'transparent',
          stroke: !_ctx.preview ? 'black' : 'transparent',
          "stroke-width": !_ctx.preview ? 0.5 : ''
        }, null, 10, _hoisted_10),
        (!_ctx.isSVG)
          ? (_openBlock(), _createBlock(_component_CustomForeignObject, {
              key: 0,
              box: _ctx.box,
              type: "basic",
              preview: _ctx.preview,
              hideMenuOptions: _ctx.hideMenuOptions
            }, null, 8, ["box", "preview", "hideMenuOptions"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}